import { useAuth } from "../context/AuthContext";
import { Button } from "./ui/button";
import { ArrowLeft, Eye } from "lucide-react";
import { useNavigate } from "react-router-dom";

const ImpersonationBanner = () => {
  const { isImpersonating, user, originalAdmin, stopImpersonating } = useAuth();
  const navigate = useNavigate();

  if (!isImpersonating) return null;

  const handleStopImpersonating = () => {
    stopImpersonating();
    navigate("/employees");
  };

  return (
    <div className="bg-amber-500 text-white px-4 py-2 flex items-center justify-between" data-testid="impersonation-banner">
      <div className="flex items-center gap-2">
        <Eye size={18} />
        <span className="font-medium">
          Viewing as <strong>{user?.name}</strong>
        </span>
        <span className="text-amber-100 text-sm">
          ({user?.email})
        </span>
      </div>
      <Button
        variant="secondary"
        size="sm"
        onClick={handleStopImpersonating}
        className="bg-white text-amber-600 hover:bg-amber-50 gap-2"
        data-testid="stop-impersonating-btn"
      >
        <ArrowLeft size={16} />
        Return to Admin ({originalAdmin?.name?.split(" ")[0]})
      </Button>
    </div>
  );
};

export default ImpersonationBanner;
